.bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.count {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--color-ink);
}

.desktopControls {
  display: flex;
  gap: 24px;
  align-items: center;
}

.select {
  min-width: 130px;
  font-size: 0.85rem;
}

.mobileBtn {
  display: none;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.18);
  padding: 10px 16px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: var(--color-ink);
  cursor: pointer;
  width: 100%;
  justify-content: center;
}

.badge {
  display: inline-block;
  background: var(--color-ember);
  color: #111;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  border-radius: 999px;
  padding: 0 7px;
  min-width: 20px;
  text-align: center;
  line-height: 18px;
}

@media (max-width: 900px) {
  .bar {
    justify-content: center;
  }
  .count { width: 100%; text-align: center; font-size: 1.4rem; }
  .desktopControls { display: none; }
  .mobileBtn { display: inline-flex; }
}

/* Drawer/sheet */
.sheet {
  border-top-left-radius: 14px !important;
  border-top-right-radius: 14px !important;
  max-height: 85dvh;
  display: flex;
  flex-direction: column;
}

.sheetHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.tabs {
  display: flex;
  gap: 8px;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 8px 14px;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  color: var(--color-ink-soft);
  border-radius: 999px;
}

.tabActive {
  border-color: var(--color-ink);
  background: var(--color-ink);
  color: #fff;
}

.closeBtn {
  border: 0;
  background: transparent;
  padding: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--color-ink);
}

.sortList {
  list-style: none;
  margin: 0;
  padding: 8px 0 8px;
  overflow-y: auto;
  flex: 1;
}

.sortRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  border: 0;
  padding: 14px 18px;
  font: inherit;
  font-size: 0.95rem;
  text-align: left;
  cursor: pointer;
  color: var(--color-ink);
}

.sortRow:hover, .sortRow:focus-visible { background: var(--color-bone); outline: none; }

.sortRowActive {
  font-weight: 700;
  color: var(--color-ember-dark);
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--color-ember);
}

.divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.06);
  margin: 6px 18px;
}

.perPageRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  font-size: 0.9rem;
  color: var(--color-ink-soft);
}

.filterBody {
  padding: 12px 18px 4px;
  overflow-y: auto;
  flex: 1;
}

.sheetFoot {
  display: flex;
  gap: 12px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
}

.clearBtn {
  flex: 0 0 auto;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.18);
  padding: 12px 18px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  color: var(--color-ink);
}

.applyBtn {
  flex: 1;
  background: var(--color-ember);
  border: 0;
  padding: 14px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  color: #111;
}
